import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@knockrentals/knock-shared-web-v2';

const TabSectionHeader = ({ className, description, title }) => {
  return (
    <div className={className}>
      <Typography role="heading" variant="subtitle1">
        {title}
      </Typography>
      <Typography color="text.tertiary" variant="caption">
        {description}
      </Typography>
    </div>
  );
};

TabSectionHeader.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string,
};

export default TabSectionHeader;
